export default __webpack_public_path__ + "static/media/number-input.bd0711b4.svg";